/** How long the preview stays white. Keep in sync with `webcam-scan-flash` in WebcamCapture.css. */
export const SCAN_SUCCESS_FLASH_MS = 240;

export type ScanCaptureResult = void | boolean | Promise<void | boolean | undefined>;

/** Page capture handlers return true only when the scan is accepted. */
export type ScanCaptureHandler = (data: string | null) => ScanCaptureResult;

export async function flashIfScanSucceeded(
  result: ScanCaptureResult,
  flash: () => void,
): Promise<void> {
  const succeeded = await result;
  if (succeeded === true) {
    flash();
  }
}

/** Leaves the preview mounted long enough for the success flash to finish. */
export function closeCameraAfterScanFlash(
  setWebcamOn: (on: boolean) => void,
): ReturnType<typeof setTimeout> {
  return setTimeout(() => {
    setWebcamOn(false);
  }, SCAN_SUCCESS_FLASH_MS);
}
